import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { usersApi } from './users.api';
import type { UsersListParams } from '../types';
import { STALE_TIME } from '@/lib/query/stale-times';

export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: (filters: UsersListParams) => [...userKeys.lists(), filters] as const,
  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: number) => [...userKeys.details(), id] as const,
  metrics: () => [...userKeys.all, 'metrics'] as const,
  nationalities: () => ['nationalities'] as const
};

export const userQueries = {
  list: (filters: UsersListParams = {}) =>
    queryOptions({
      queryKey: userKeys.list(filters),
      queryFn: () => usersApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: userKeys.detail(id),
      queryFn: () => usersApi.getById(id),
      enabled: id > 0
    }),

  metrics: () =>
    queryOptions({
      queryKey: userKeys.metrics(),
      queryFn: () => usersApi.metrics(),
      staleTime: STALE_TIME.metrics
    }),

  nationalities: () =>
    queryOptions({
      queryKey: userKeys.nationalities(),
      queryFn: () => usersApi.nationalities(),
      staleTime: STALE_TIME.frozen
    })
};
